import axiosInstance from './axiosConfig';

export async function getTranscript(videoId) {
    return axiosInstance.post(`/transcripts/${videoId}`);
}